import React from 'react';
import {Redirect} from 'react-router-dom';
import Main from '../pages/Main';
import Login from '../pages/Login';
import DriverList from '../pages/driver';
import EditDriverInfo from '../pages/driver';
import ParcelReturn from '../pages/parcelReturn';
import ProtectedRoute from './protectedRoute';
import ResendOrderManagement from '../pages/resendOrders';
import SlotAssignment from '../pages/SlotAssignment'
import BatchManagement from '../pages/BatchManagement';
import UserManagementNew from '../pages/UserManagementNew';
import LocalDelivery from '../pages/LocalDelivery';
import IncidentManagement from '../pages/IncidentManagement';
import DeliveryAreaManagement from '../pages/DeliveryAreaManagement';
import WrongAddressTool from '../pages/WrongAddressTool';
import DriverEfficiencyMonitor from '../pages/DriverEfficiencyMonitor';
import PayrollAdjustment from   '../pages/PayrollAdjustment';
import SelfPickup from '../pages/SelfPickup';
import OrderExchangeStatistics from '../pages/OrderExchangeStatistics';
import OrderForawardTool from '../pages/OrderForwardTool';
import SortingMachineManagement from '../pages/SortingMachine';

export const routes = [
    {
        path:'/login',
        component: Login
    },
    {
        component: ProtectedRoute,
        routes: [
            {
                path: '/main',
                component: Main
            },
            {
                path: "/",
                exact: true,
                render: () => {
                    return <Redirect to={'/main'}></Redirect>
                }
            },
            {
                path:'/resend-order-management',
                component: ResendOrderManagement
            },
            // {
            //     path:'/parcel-return',
            //     component: ParcelReturn,
            //     routes:[
            //     ]
            // },
            // {
            //     path:'/editOrder',
            //     component: EditOrder,
            //     routes:[
            //     ]
            // },
            {
                path:'/slot-assignment',
                component: SlotAssignment
            },
            {
                path:'/batch-management',
                component: BatchManagement
            },
            {
                path:'/local-delivery',
                component: LocalDelivery
            },
            {
                path:'/incident-management',
                component: IncidentManagement
            },
            {
                path:'/user-management',
                component: UserManagementNew
            },
            {
                path:'/delivery-area-management',
                component: DeliveryAreaManagement
            },
            {
                path:'/wrong-address-tool',
                component: WrongAddressTool
            },
            {
                path:'/driver-efficiency-management',
                component: DriverEfficiencyMonitor
            },
            {
                path:'/order-forward-tool',
                component: OrderForawardTool
            },
            {
                path:'/payroll-adjustment-management',
                component: PayrollAdjustment
            },
            {
                path: '/self-pickup-tool',
                component: SelfPickup
            },
            {
                path:'/order-exchange-statistics',
                component: OrderExchangeStatistics
            },
            {
                path: '/sorting-machine-management',
                component: SortingMachineManagement
            }
        ]
    }
]